export const Table = 'atlantis-table';